import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    matutina: null,
    playing: false,
    horario: null,
    today: null
  },
  getters: {
    getMatutina (state) {
      return state.matutina
    },
    getPlaying (state) {
      return state.playing
    },
    getHorario (state) {
      return state.horario
    },
    getToday (state) {
      return state.today
    }
  },
  mutations: {
    setMatutina (state, value) {
      state.matutina = value
    },
    setPlaying (state, value) {
      state.playing = value
    },
    setHorario (state, value) {
      state.horario = value
    },
    setToday (state, value) {
      state.today = value
    }
  },
  actions: {
  },
  modules: {
  }
})
